/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import ResponsiveTable from "../../components/ResponsiveTable";
import { Checkbox, Button, Form, message, Modal } from "antd";
import TableLineIcons from "../../components/TableLineIcons";
import GenericModal from "../../components/GenericModal";
import GenericForm from "../../components/GenericForm";
import TableIDs from "../../data/TableIDs";
import moment from "moment";


class SelfServiceSpecialPages extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            sorter: { field: "_PosName", order: "ascend" },
            filterText: ""
        };

        this.id = "SELF_SERVICE_SPECIAL_PAGES";

        this.api = {
            get: "get_self_service_special_pages",
            create: "create_self_service_special_pages",
            edit: "edit_self_service_special_pages",

            selectorPage: "get_button_layout_pages_list",

        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        if (props.data[TableIDs.genericSelectorButtonPage] === undefined) props.data[TableIDs.genericSelectorButtonPage] = { ...props.data.genericSelector };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.refreshData()
    }

    componentDidUpdate(p) {
        document.title = "Cash On Tab - " + this.getText(21145);

        let prevPos = p.data[this.id].editedRecord._PosID
        let curPos = this.props.data[this.id].editedRecord._PosID

        if (prevPos !== curPos) this.refreshPages(curPos)
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    refreshPages = (mPOSID) => {
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorButtonPage, this.props.user.companyCode, this.props.user.token, this.api.selectorPage, { mPOSID }]
        });
    }

    getDataSource = () => {
        const { sorter, filterText } = this.state;
        const { data, headers } = this.props.data[this.id]
        let field = sorter.field ?? "_PosName"
        let order = sorter.order ?? "ascend"
        return data.filter(f => {
            return !filterText || f.indexOf(filterText) > -1
        }).map((x, index) => {
            let y = x.split("\f")
            let res = { key: y[0], index }
            headers.forEach((z, i) => { res = { ...res, [z]: y[i] } })
            return res
        }).sort((a, b) => {
            return (order == "ascend") ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field])
        })
    }

    renderEditCol = (t, record) => {
        return (<TableLineIcons
            onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index) }}
        />)
    }

    handleCancel = () => {
        if (this.props.data[this.id].editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
        else this.props.dataActions.genericDataCancelEditing(this.id);
    }

    handleOk = () => {
        const { data, headers, editedRecord } = this.props.data[this.id]
        const { _PosID, _StartPageNum } = editedRecord
        if (!_PosID || !_StartPageNum) {
            message.error(this.getText(21162))
        } else {
            const saveData = () => {
                let script = this.props.data[this.id].editing == 0 ? this.api.create : this.api.edit
                this.props.dataActions.genericDataSaveEdit(this.id, this.props.user.companyCode, this.props.user.token, script, this.api.get);
            }

            let findSimilar = data.map((x, index) => {
                let y = x.split("\f")
                let res = { key: y[0], index }
                headers.forEach((z, i) => { res = { ...res, [z]: y[i] } })
                return res
            }).find(f => {
                let isOverlap = f.key != editedRecord.key && f._PosID == editedRecord._PosID
                if (f._CustTagID && editedRecord._CustTagID && f._CustTagID != editedRecord._CustTagID) isOverlap = false
                if (this.getTimeSec(f._FromHour) > this.getTimeSec(editedRecord._ToHour, true)) isOverlap = false
                if (this.getTimeSec(editedRecord._FromHour) > this.getTimeSec(f._ToHour, true)) isOverlap = false
                if (!f._DaysOfWeek || !editedRecord._DaysOfWeek || !f._DaysOfWeek.split(",").find(ff => editedRecord._DaysOfWeek.indexOf(ff) > -1)) isOverlap = false
                return isOverlap
            })

            if (findSimilar) {
                Modal.confirm({
                    content: (<h4>
                        {this.getText(21165)} {findSimilar._PosName}<br />
                        {this.getText(findSimilar._CustTagName ? 21167 : 21166)} {findSimilar._CustTagName}<br />
                        {this.getText(21168)} {this.renderHour(findSimilar._FromHour)} -  {this.renderHour(findSimilar._ToHour)}<br />
                        {this.getText(21169)} {this.renderDays(findSimilar._DaysOfWeek)}<br />
                        {this.getText(21170)}
                    </h4>),
                    iconType: 'exclamation-circle',
                    okText: this.getText(21171),
                    cancelText: this.getText(21172),
                    onOk: saveData,
                    onCancel() { },
                })
            } else {
                saveData()
            }
        }
    }

    getTimeSec = (time, to) => {
        return (!time) ? (to ? 60 * 60 * 24 : 0) : moment.duration(time).asSeconds()
    }

    createNew = () => {
        this.props.dataActions.genericDataStartInlineCreate(this.id)
        setTimeout(() => {
            this.props.dataActions.genericDataSetEdit(this.id, {
                _FromHour: "00:00:00",
                _ToHour: "23:59:59",
                _DaysOfWeek: "1,2,3,4,5,6,7",
                _IsActive: "1"
            })
        }, 100);
    }

    renderHour = (t) => t ? t.split(":").slice(0, 2).join(":") : "";
    renderDays = (t) => t ? t.split(",").map(x => ' אבגדהוז'.split('')[x]).join(",") : "";


    render() {
        const gt = this.getText;
        const { editing, editedRecord } = this.props.data[this.id]
        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        let sorter = true;
        let render = t => t;

        let numOfRowsByHeight = parseInt((window.innerHeight - 400 > 30) ? (window.innerHeight - 400) / 30 : 1);


        return (<div style={divStyle}>
            <ResponsiveTable
                dataSource={this.getDataSource()}
                rowsFilter={r => r.key > 0}
                title={gt(21145)}
                columns={[
                    { title: gt(21146), key: "_PosName", dataIndex: "_PosName", sorter, render },
                    { title: gt(21147), key: "_CustTagName", dataIndex: "_CustTagName", sorter, render },
                    { title: gt(21148), key: "_FromHour", dataIndex: "_FromHour", sorter, render: this.renderHour },
                    { title: gt(21149), key: "_ToHour", dataIndex: "_ToHour", sorter, render: this.renderHour },
                    { title: gt(21150), key: "_DaysOfWeek", dataIndex: "_DaysOfWeek", sorter, render: this.renderDays },
                    { title: gt(21151), key: "_StartPageName", dataIndex: "_StartPageName", sorter, render },
                    { title: gt(21152), key: "_SidePageName", dataIndex: "_SidePageName", sorter, render },
                    { title: gt(21153), key: "_IsActive", dataIndex: "_IsActive", sorter, render: t => (<Checkbox checked={t == 1} disabled />) },
                    { title: gt(21154), render: this.renderEditCol },
                ]}
                actionButtons={[{
                    buttonType: 'add',
                    buttonFunction: this.createNew
                }, {
                    buttonType: 'refresh',
                    buttonFunction: this.refreshData
                }]}
                pagination={{ pageSize: numOfRowsByHeight }}
                onChange={(p, f, sorter) => { this.setState({ sorter }) }}
                showsearch={filterText => { this.setState({ filterText }) }}
            />

            <GenericModal
                visible={editing > -1}
                onCancel={this.handleCancel}
                title={gt(21155)}
                width={1000}
                footer={[
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(21156)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleOk} style={{ margin: 5 }}>{gt(21157)}</Button>,
                ]}>
                <GenericForm
                    columnCount={2}
                    value={editedRecord}
                    onChange={obj => { this.props.dataActions.genericDataSetEdit(this.id, obj) }}
                    fields={[
                        { label: gt(21146), key: "_PosID", inputType: "posSelector", inputProps: this.props, isMandatory: true },
                        { label: gt(21147), key: "_CustTagID", inputType: "custTagSelector", inputProps: this.props, },
                        { label: gt(21148), key: "_FromHour", inputType: "time" },
                        { label: gt(21149), key: "_ToHour", inputType: "time" },
                        { label: gt(21150), key: "_DaysOfWeek", inputType: "daysOfWeek" },
                        { label: gt(21151), key: "_StartPageNum", inputType: "selector", inputProps: { ...this.props, id: TableIDs.genericSelectorButtonPage }, isMandatory: true },
                        { label: gt(21152), key: "_SidePageNum", inputType: "selector", inputProps: { ...this.props, id: TableIDs.genericSelectorButtonPage } },
                        { label: gt(21153), key: "_IsActive", inputType: "checkbox" },
                    ]}
                />
            </GenericModal>
        </div>)
    }

}

export default SelfServiceSpecialPages;